// Import utils
import { createSnackbar } from '@automator/shared/utils/create-snackbar';
import { isEmpty } from '@automator/shared/utils/is-empty';

/**
 * Shows an error message in a Snackbar
 *
 * @param {String} message The error message to show
 * @return {Node|undefined} The Snackbar object
 */
const showError = message => {
	// Check if the message is empty
	if ( isEmpty( message ) ) {
		return;
	}

	// Show Snackbar with error message
	return createSnackbar( {
		message: message,
		color: 'error',
		iconID: 'times-circle-solid',
		duration: 5000
	} );
}

export default showError;
